import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import { AxiosResponse } from 'axios'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIxPrnSrvcPrinterListStatus: 'idle',
    loadIxPrnSrvcPrinterListError: undefined as any,
    loadIxPrnSrvcPrinterListLastArgs: undefined as any,
    loadIxPrnSrvcPrinterStatus: 'idle',
    loadIxPrnSrvcPrinterError: undefined as any,
    saveIxPrnSrvcPrinterStatus: 'idle',
    saveIxPrnSrvcPrinterError: undefined as any,
    deleteIxPrnSrvcPrinterStatus: 'idle',
    deleteIxPrnSrvcPrinterError: undefined as any,

    ixPrnSrvcPrinterList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}

const prepParams = (url: string, globalFilters: any) => {
    const params: any = {}

    if (!url.includes('action=')) {
        params['action'] = 'gte'
    }


    return params
}

const getRespData = (res: AxiosResponse, rejectWithValue: Function | null, singleRes = false) => {
    let data: any = undefined
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            if (rejectWithValue) {
                throw rejectWithValue(parseMessages(res.data.messages))
            }
        } else {
            data = res.data.data
        }
    } else {  // backend response
        data = res.data
    }

    if (singleRes && data) {
        if (!data || (Array.isArray(data) && data.length === 0)) {
            if (rejectWithValue) {
                throw rejectWithValue('No data found')
            }
        } else {
            return Array.isArray(data) ? data[0] : data
        }
    } else {
        return data
    }
}

export const loadIxPrnSrvcPrinterList = createAsyncThunk('ixPrnSrvcPrinterSlice/loadIxPrnSrvcPrinterList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ixPrnSrvcPrinterSlice.loadIxPrnSrvcPrinterListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvcprinter/?action=gte&IXPRNSRVCID_FILTER=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
})

export const loadIxPrnSrvcPrinter = createAsyncThunk('ixPrnSrvcPrinterSlice/loadIxPrnSrvcPrinter', async ({ id, parentModel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvcprinter/?action=eql&HDR_ID=${id}`,
    ))

    const [ixPrnSrvcPrinterRes] = await Promise.all(promises)
    const ixPrnSrvcPrinter = getRespData(ixPrnSrvcPrinterRes, rejectWithValue, true)
    promises = []
    promises.push(client.get(
        `/api/ixweb/ixprnsrvcrel/?action=eql&PRINTSRVCID=${parentModel.HDR_ID}&PrinterId=${ixPrnSrvcPrinter.HDR_ID}`,
    ))

    const [ixPrnSrvcRelRes] = await Promise.all(promises)
    const ixPrnSrvcRel = getRespData(ixPrnSrvcRelRes, null, true)

    return {
        data: {
            ...ixPrnSrvcPrinter,
            ixPrnSrvcRel: { ...ixPrnSrvcRel },
        }
    }
})

export const saveIxPrnSrvcPrinter = createAsyncThunk('ixPrnSrvcPrinterSlice/saveIxPrnSrvcPrinter', async ({ ixPrnSrvcPrinter }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ixPrnSrvcPrinter.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ixprnsrvcprinter/${ ixPrnSrvcPrinter.HDR_ID }/`,
            prepareData(ixPrnSrvcPrinter),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ixprnsrvcprinter/`,
            prepareData(ixPrnSrvcPrinter),
        ))
    }
    if (ixPrnSrvcPrinter.ixPrnSrvcRel.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ixprnsrvcrel/${ ixPrnSrvcPrinter.ixPrnSrvcRel.HDR_ID }/`,
            prepareData(ixPrnSrvcPrinter.ixPrnSrvcRel),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ixprnsrvcrel/`,
            prepareData(ixPrnSrvcPrinter.ixPrnSrvcRel),
        ))
    }

    const [value1Res, value2Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)
    const value2 = getRespData(value2Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
            value2: { ...value2 },
        }
    }
})

export const deleteIxPrnSrvcPrinter = createAsyncThunk('ixPrnSrvcPrinterSlice/deleteIxPrnSrvcPrinter', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ixprnsrvcprinter/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
})

const IxPrnSrvcPrinterSlice = createSlice({
    name: 'ixPrnSrvcPrinterSlice',
    initialState,
    reducers: {
        resetloadIxPrnSrvcPrinterListError: (state) => {
            state.loadIxPrnSrvcPrinterListError = undefined
        },
        resetloadIxPrnSrvcPrinter: (state) => {
            state.formItem = undefined
            state.loadIxPrnSrvcPrinterError = undefined
        },
        resetloadIxPrnSrvcPrinterError: (state) => {
            state.loadIxPrnSrvcPrinterError = undefined
        },
        resetsaveIxPrnSrvcPrinter: (state) => {
            state.formItem = undefined
            state.saveIxPrnSrvcPrinterError = undefined
        },
        resetsaveIxPrnSrvcPrinterError: (state) => {
            state.saveIxPrnSrvcPrinterError = undefined
        },
        resetdeleteIxPrnSrvcPrinterError: (state) => {
            state.deleteIxPrnSrvcPrinterError = undefined
        },
        removeFromIxPrnSrvcPrinterListById: (state, action) => {
            state.ixPrnSrvcPrinterList = state.ixPrnSrvcPrinterList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.ixPrnSrvcPrinterList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIxPrnSrvcPrinterListStatus = 'preloaded'
            state.loadIxPrnSrvcPrinterListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ixPrnSrvcPrinterList = []
            state.loadIxPrnSrvcPrinterListStatus = 'idle'
            state.loadIxPrnSrvcPrinterListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIxPrnSrvcPrinterList.pending, (state) => {
            state.loadIxPrnSrvcPrinterListStatus = 'pending'
            state.loadIxPrnSrvcPrinterListError = undefined
        })
        builder.addCase(loadIxPrnSrvcPrinterList.fulfilled, (state, action) => {
            state.loadIxPrnSrvcPrinterListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIxPrnSrvcPrinterListLastArgs = action.payload.args

            {
                state.ixPrnSrvcPrinterList = action.payload.data

            }
        })
        builder.addCase(loadIxPrnSrvcPrinterList.rejected, (state, action) => {
            state.loadIxPrnSrvcPrinterListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIxPrnSrvcPrinterListError = action.error.message
            } else {
                state.loadIxPrnSrvcPrinterListError = action.payload
            }
        })

        builder.addCase(loadIxPrnSrvcPrinter.pending, (state) => {
            state.loadIxPrnSrvcPrinterStatus = 'pending'
            state.loadIxPrnSrvcPrinterError = undefined
        })
        builder.addCase(loadIxPrnSrvcPrinter.fulfilled, (state, action) => {
            state.loadIxPrnSrvcPrinterStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ixPrnSrvcPrinterList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ixPrnSrvcPrinterList.push(newItem) }
                else { state.ixPrnSrvcPrinterList[i] = { ...state.ixPrnSrvcPrinterList[i], ...newItem } }
            }
        })
        builder.addCase(loadIxPrnSrvcPrinter.rejected, (state, action) => {
            state.loadIxPrnSrvcPrinterStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIxPrnSrvcPrinterError = action.error.message
            } else {
                state.loadIxPrnSrvcPrinterError = action.payload
            }
        })

        builder.addCase(saveIxPrnSrvcPrinter.pending, (state) => {
            state.saveIxPrnSrvcPrinterStatus = 'pending'
            state.saveIxPrnSrvcPrinterError = undefined
        })
        builder.addCase(saveIxPrnSrvcPrinter.fulfilled, (state, action) => {
            state.saveIxPrnSrvcPrinterStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ixPrnSrvcPrinterList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ixPrnSrvcPrinterList.push(newItem) }
                else { state.ixPrnSrvcPrinterList[i] = { ...state.ixPrnSrvcPrinterList[i], ...newItem } }
            }
        })
        builder.addCase(saveIxPrnSrvcPrinter.rejected, (state, action) => {
            state.saveIxPrnSrvcPrinterStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIxPrnSrvcPrinterError = action.error.message
            } else {
                state.saveIxPrnSrvcPrinterError = action.payload
            }
        })

        builder.addCase(deleteIxPrnSrvcPrinter.pending, (state) => {
            state.deleteIxPrnSrvcPrinterStatus = 'pending'
            state.deleteIxPrnSrvcPrinterError = undefined
        })
        builder.addCase(deleteIxPrnSrvcPrinter.fulfilled, (state, action) => {
            state.deleteIxPrnSrvcPrinterStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ixPrnSrvcPrinterList = state.ixPrnSrvcPrinterList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ixPrnSrvcPrinterList = state.ixPrnSrvcPrinterList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIxPrnSrvcPrinter.rejected, (state, action) => {
            state.deleteIxPrnSrvcPrinterStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIxPrnSrvcPrinterError = action.error.message
            } else {
                state.deleteIxPrnSrvcPrinterError = action.payload
            }
        })

    }
})

export const {
    resetloadIxPrnSrvcPrinterListError,
    resetloadIxPrnSrvcPrinter,
    resetloadIxPrnSrvcPrinterError,
    resetsaveIxPrnSrvcPrinter,
    resetsaveIxPrnSrvcPrinterError,
    resetdeleteIxPrnSrvcPrinterError,
    removeFromIxPrnSrvcPrinterListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = IxPrnSrvcPrinterSlice.actions
export default IxPrnSrvcPrinterSlice.reducer
